import React, {useState} from "react"
import Row from "@amzn/meridian/row"
import Button from "@amzn/meridian/button"
import ModalExample from "@amzn/meridian/modal";
import Box from "@amzn/meridian/box";
import ModalFooter from "@amzn/meridian/modal/modal-footer";
import Column from "@amzn/meridian/column";
import Alert from "@amzn/meridian/alert";
import AlertModal from "./alertModal";
import CoinRemittanceSection from "./deposit/coinRemittanceSection";
import SectionDetails from "./deposit/sectionDetails";
import Input from "@amzn/meridian/input";
import {CurrencySymbol} from "../common/constants";
import {getStationCode} from "../../network/NetworkUtil";
import {submitCoinRemittanceRequest} from '../remittance/network/RemittanceAPI';
import commonUtils from "../common/commonUtils";

const OverviewSection = ({currencyUnit, onActualCashSubmittedChange}) => {
    const currencySymbol = CurrencySymbol[currencyUnit];
    const [actualCashSubmitted, setActualCashSubmitted] = useState(0);

    const handleActualCashSubmittedChange = event => {
        console.log({event});
        setActualCashSubmitted(event);
        onActualCashSubmittedChange(event);
    };
    return (<Box>
        <Row>
            <SectionDetails title="Overview" description="Add the Deposit Code for the coins and notes rejected by the CDM machines"/>
        </Row>
        <Column spacing="medium">
            <Row widths="grid-8">
                <SectionDetails title="Details" description="Enter the amount to be created for this deposit"/>
            </Row>
            <Row width="100%" widths="grid-8">
                <Input
                    label="Amount"
                    type="number"
                    prefix={currencySymbol}
                    onChange={handleActualCashSubmittedChange}
                    value={actualCashSubmitted}
                />
            </Row>
        </Column>
    </Box>);
}

const AddCoinDepositModal = (props) => {

    const {currencyUnit} = props;
    const [actualCashSubmitted, setActualCashSubmitted] = useState(0);
    const [remittanceCode, setRemittanceCode] = useState();
    const [confirmRemittanceCode, setConfirmRemittanceCode] = useState();

    const [alertMessage, setAlertMessage] = useState();
    const [alertModal, setAlertModal] = useState({show: false});

    const onClose = event => {
        setAlertMessage(undefined);
        props.onClose(event);
    }

    const onAlertModelClose = event => {
        setAlertModal({show: false});
        onClose(event);
        window.location.reload();
    }

    const submitCoinRemittance = event => {

        function validateCoinRemittanceCode(remittanceCode, confirmRemittanceCode) {
            if (!remittanceCode || remittanceCode !== confirmRemittanceCode) {
                setAlertMessage({type: "error", message: "Remittance code mismatch"});
                return false;
            }

            return commonUtils.isValidCoinRemittanceCode(remittanceCode) && remittanceCode === confirmRemittanceCode

        }

        //send adhoc coin remittance request
        if (validateCoinRemittanceCode(remittanceCode, confirmRemittanceCode)) {
            console.log("coin deposit api call")
            return submitCoinRemittanceRequest({
                stationCode: getStationCode(),
                actualCashSubmitted: {
                    unit: currencyUnit,
                    value: parseFloat(actualCashSubmitted)
                },
                remittanceCode,
            }).then(response => {
                if (response.status === 200) {
                    setAlertModal({
                        show: true,
                        title: "Success",
                        message: "Successfully added the new deposit for coins",
                        type: "success"
                    })
                } else {
                    setAlertMessage({type: "error", message: "Failed to Add coin deposit code."});
                }
            }).catch(error => {
                setAlertMessage({type: "error", message: "Failed to Add coin deposit code."});
            })
        } else {
            setAlertMessage({type: "warning", message: "Invalid remittance code"});
            return false;
        }

    }

    return (
        <React.Fragment>
            {
                <React.Fragment>
                    <ModalExample title="Add Deposit Code" open={props.value} scrollContainer="viewport"
                                  closeLabel="Close" onClose={onAlertModelClose}>
                        {alertMessage && <Alert type={alertMessage.type}>{alertMessage.message}</Alert>}
                        <Box>
                            <form>
                                <Column spacing="medium">
                                    <OverviewSection
                                        onActualCashSubmittedChange={setActualCashSubmitted}
                                        currencyUnit={currencyUnit}
                                    />
                                    <CoinRemittanceSection
                                        onRemittanceCodeChange={setRemittanceCode}
                                        onConfirmRemittanceCodeChange={setConfirmRemittanceCode}
                                        currencyUnit={currencyUnit}
                                    />
                                </Column>
                            </form>
                        </Box>
                        <ModalFooter>
                            <Row alignmentHorizontal="right" widths="fit">
                                <Button type="secondary" size="medium" onClick={onClose}>
                                    Cancel
                                </Button>
                                <Button type="primary" size="medium" onClick={submitCoinRemittance}>
                                    Done
                                </Button>
                            </Row>
                        </ModalFooter>
                    </ModalExample>

                    <AlertModal
                        show={alertModal.show}
                        title={alertModal.title}
                        type={alertModal.type}
                        message={alertModal.message}
                        onClose={onAlertModelClose}
                    />
                </React.Fragment>}
        </React.Fragment>
    );
}

export default AddCoinDepositModal;



// WEBPACK FOOTER //
// ./src/component/modal/addCoinDepositModal.js